import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { ParametersService } from '@modules/business-accounts/services/parameters/parameters.service';
import { MAX_NUMBER_ACCOUNTS } from '@modules/business-accounts/utils/constants/user-workflow-constants';
import { AssetLink } from '@utils/helpers/asset-cpm-link';
import { map, Observable } from 'rxjs';
import { Currency } from '@domain/model/enums/currency/currency.enum';

@Component({
  selector: 'ba-configuration-step',
  templateUrl: './configuration-step.component.html',
  styleUrls: ['./configuration-step.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class ConfigurationStepComponent extends AssetLink() implements OnInit {
  @Input() isClient: boolean = false;
  @Input() isPJ: boolean = false;
  @Input() accountsNumber: number = 0;

  showPlanDetails: boolean = false;
  showItemAccountBusiness: boolean = true;
  showItemAccountBusinessPJ: boolean = false;
  titleViewDetails: string = 'Ver detalles';

  currency$!: Observable<any>;

  constructor(public readonly paramsService: ParametersService) {
    super();
  }

  onPlanDetailsClick() {
    this.showPlanDetails = !this.showPlanDetails;
  }

  ngOnInit(): void {
    this.currency$ = this.paramsService.params$('currency').pipe(
      map((currency) => {
        if (this.accountsNumber === MAX_NUMBER_ACCOUNTS - 1) {
          return currency.filter(({ value }) => value !== Currency.BOTH);
        }
        return currency;
      })
    );
  }

  evtYourBusinessAccountPN(btn: any) {
    btn.preventDefault();
    this.showItemAccountBusiness = !this.showItemAccountBusiness;
    this.titleViewDetails = this.showItemAccountBusiness ? 'Ver detalles' : 'Ocultar detalle';
  }

  evtYourBusinessAccountPJ(btn: any) {
    btn.preventDefault();
    this.showItemAccountBusinessPJ = !this.showItemAccountBusinessPJ;
    this.titleViewDetails = this.showItemAccountBusinessPJ ? 'Ocultar detalle' : 'Ver detalles';
  }
}